<template>
  <BaseContainer>
<BaseContentContainer>
  <h1 class="display-6 text-center">Our Teaching Approach</h1>
  <p class="lead text-center mb-5">
  Our teaching philosophy focuses on clarity, confidence, and critical thinking. We tailor our sessions to meet individual student needs, using real-world examples, active problem-solving, and personalised feedback to ensure lasting understanding — not just memorisation.
</p>
<div class="accordion" id="teachingAccordion">
    <div v-for="item in teachingPoints" :key="item.id">

        <GenericAccordion 
           :key="item.id"
           :object="item">
        </GenericAccordion>
        
    </div>
</div>
  </BaseContentContainer>
</BaseContainer>
</template>

<script>
import GenericAccordion  from '@/components/GenericAccordion.vue';
//import GenericCard from '@/components/GenericCard.vue';
import BaseContainer  from '@/components/BaseContainer.vue';
import BaseContentContainer  from '@/components/BaseContentContainer.vue';
export default {
  name: 'TeachingView',
    components: {
      GenericAccordion , BaseContainer,BaseContentContainer,
  },

  data() {
    return {
     teachingPoints: [
  {
    id : 1,
    title: 'Customised Lessons',
    description: 'Every student is unique, and so are their learning needs. We tailor our lessons to suit individual learning styles, focusing on concepts that need attention while building on existing strengths. This ensures optimal progress at a comfortable pace.'
  },
  {
     id : 2,
    title: 'Subject Confidence Building',
    description: 'Struggling with algorithms or programming? We help students overcome barriers by breaking down complex topics, encouraging a positive mindset, and building confidence in their abilities to succeed.'
  },
  {
     id : 3,
    title: 'Amplifying Your Interest',
    description: 
    `
    Passion drives performance. Through engaging teaching methods, real-world practical projects, and hands-on experiences, we help ignite or deepen an interest in Computer Science, making learning enjoyable and rewarding. 
    And we do this by indulging into scenarios that involve working with simulations, games and physical computing. 
    
    `
  },
  {
    id : 4,
    title: 'Augmenting Your Knowledge',
    description: 'We expand students\' understanding beyond the classroom curriculum, offering insights into advanced concepts and trends. This not only aids in coursework but prepares them for future challenges.'
  },
  {
     id : 5,
    title: 'Project Understanding',
    description: 'Navigating project work can be daunting. We guide students through project planning, execution, and presentation, ensuring clarity and mastery of essential skills.'
  },
  {
    id : 6,
    title: 'Exams Preparations',
    description: 'Effective preparation is the key to success. We offer strategic revision plans, practice exams, and targeted support to boost confidence and achieve excellent results.'
  }
]
      
    };
  }
};
</script>

<style scoped>

</style>
